// Use this file to store all UI strings in the FE (translated by editors).
const translationStrings = {
  example: Drupal.t('Example'),
  submitting: Drupal.t('Submitting…'), // Senden…
  submissionFailed: Drupal.t('Submission failed.'), // Senden fehlgeschlagen
  yes: Drupal.t('Yes'), // Ja
  no: Drupal.t('No'), // Nein
  sendMessage: Drupal.t('Send message'), // Nachricht absenden
  requestSupportOptimization: Drupal.t('Request support for digital optimization'), // Unterstützung für digitale Optimierung anfragen
  requestSupportMarketing: Drupal.t('Request support for digital marketing'), // Unterstützung für digitale Vermarktung anfragen
  loadingQuestions: Drupal.t('Loading questions...'), // Fragen werden geladen...
  retryAgain: Drupal.t('Try again'), // Erneut versuchen
  noQuestionsAvailable: Drupal.t('No questions available'), // Keine Fragen verfügbar
  questionsNotFound: Drupal.t('Questions not found'), // Keine Fragen gefunden
  errorLoadingQuestions: Drupal.t('Error loading questions. Please try again.'), // Fehler beim Laden der Fragen. Bitte versuchen Sie es erneut.
  allQuestionsAnswered: Drupal.t('All questions answered'), // Alle Fragen beantwortet
  questionsImpression: Drupal.t('I hope these questions have given you a good first impression of the challenges I can support you with.'), // Ich hoffe, diese Fragen haben Ihnen einen guten ersten Eindruck davon vermittelt, bei welchen Herausforderungen ich Sie unterstützen kann.
  reopenForm: Drupal.t('Reopen form'), // Formular wieder öffnen
  reloadQuestions: Drupal.t('Reload questions'), // Fragen neu laden
  personalInformation: Drupal.t('Personal information'), // Persönliche Angaben
  thankYou: Drupal.t('Thank you!'), // Vielen Dank!
  messageSubmitted: Drupal.t('Your message has been successfully submitted. I will get back to you promptly.'), // Ihre Nachricht wurde erfolgreich übermittelt. Ich melde mich zeitnah bei Ihnen zurück.
  unknownQuestion: Drupal.t('Unknown question'), // Unbekannte Frage
};

export default translationStrings;
